const FullLoader = ({ label = "Cargando..." }: { label?: string }) => (
  <div className="attd-app-bg min-h-screen flex flex-col items-center justify-center gap-4">
    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-primary-800 border border-accent-500/40 flex items-center justify-center animate-pulse-ring">
      <span className="font-heading font-extrabold text-accent-300 text-lg">ATT</span>
    </div>
    <p className="text-sm text-foreground-600 flex items-center gap-2">
      <i className="ri-loader-4-line animate-spin" /> {label}
    </p>
  </div>
);

export default FullLoader;